import React from "react";
import { Box, Typography } from "@mui/material";
import Image from "next/image";
import { ColletteButton } from "@collette-travel/collette-common-controls";

export interface PomCardProps {
  iconUrl: string;
  iconAltText: string;
  copyText: string;
  headerText?: string;
  ctaLink?: string;
  buttonVariant?: {
    variant?: "contained" | "outlined";
    color?: "primary" | "secondary";
  };
  index: number;
  ctaText?: string;
  theme?: "Light" | "Dark";
}

const PomCard: React.FC<PomCardProps> = ({
  iconUrl,
  iconAltText,
  copyText,
  index,
  headerText,
  ctaLink,
  ctaText,
  theme,
  buttonVariant
}) => (
  <Box
    sx={{
      p: "3.2rem 2.4rem",
      backgroundColor: theme === "Dark" ? "background.paper" : "background.warm_strong",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      textAlign: "center",
      boxShadow: 6,
      borderRadius: "2rem",
      flex: 1,
      width: "100%",
      gap: "2.4rem"
    }}
  >
    {iconUrl && (
      <Box sx={{ width: { xs: 48, md: 64 }, height: { xs: 48, md: 64 }, position: "relative" }}>
        <Image
          src={iconUrl}
          alt={`${iconAltText} icon`}
          fill
          data-testid={`pom-card-image-${index}`}
        />
      </Box>
    )}
    <Box sx={{ flex: 1, color: "background.brand" }}>
      {headerText && (
        <Typography
          component="h3"
          data-testid={`pom-card-title-${index}`}
          sx={{
            fontSize: { xs: "1.8rem", sm: "2rem" },
            fontWeight: "600",
            lineHeight: "2.6rem"
          }}
        >
          {headerText}
        </Typography>
      )}
      <Typography
        component="div"
        variant="body1"
        fontWeight="400"
        data-testid={`pom-card-copy-${index}`}
        sx={{ "& p": { marginBottom: 0 } }}
        dangerouslySetInnerHTML={{ __html: copyText ?? "" }}
      />
    </Box>
    {ctaLink && (
      <ColletteButton
        testId={`pom-card-cta-${index}`}
        component="a"
        label={ctaText || "Learn More"}
        href={ctaLink}
        variant={buttonVariant?.variant ?? (theme === "Dark" ? "outlined" : "contained")}
        color={buttonVariant?.color ?? (theme === "Dark" ? "primary" : "secondary")}
      />
    )}
  </Box>
);

export default PomCard;
